// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2exTg","calendarButtons":"ClockData_calendarButtons__tyRkC"};